import { render, staticRenderFns } from "./invitacion_tab_empleado.vue?vue&type=template&id=a13f0ab2&scoped=true"
import script from "./invitacion_tab_empleado.vue?vue&type=script&lang=js"
export * from "./invitacion_tab_empleado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13f0ab2",
  null
  
)

export default component.exports